// extracted by mini-css-extract-plugin
export default {"candidates":"styles_candidates__azn+A","scroll":"styles_scroll__F5Af2","noFavorites":"styles_noFavorites__QGwzx"};